<template>
  <div class="h-100">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
    <div class="py-3 h-100">
      <div class="row mx-0 mb-3 w-100 blockAction">
        <div class="blockAction__left">
          <div class="px-1 d-flex align-items-center">
            <div class="blockAction__totalRecords px-1">{{displayTotalRecords}}</div>
            <!-- <button
              type="button"
              :class="[isCheckValueSearched ? 'handle_btn_search' : '']"
              class="btn blockAction__btnSearch d-flex flex-row align-items-center p-0"
              @click="showModalSearch"
            >
              <span class="icon_search_btn material-icons material-icons-outlined mr-1">
                search
              </span>
              検索
            </button>
            <div class="d-flex blockAction__blockTags" v-if="isCheckValueSearched">
              <span v-for="key in searchFieldNames" :key="key" class="tag">
                <span class="text">{{ formatedValue(key) }}</span>
                <i class="material-icons material-icons-outlined" @click="onDeleteTaggedField(key)">close</i>
              </span>
            </div> -->
          </div>
          <div class="d-flex align-items-center">
            <other-button ref="extOtherButtonDropdown" buttonContent="CSV">
              <template v-slot:other-buttons>
                <csv-export-button :mapping-no="`ie-batch`" :current-query-in-storage="sortParams" :is-display-button="false" @on-export="hideDropdownCsv" @is-loading="(loading) => isLoading = loading"/>
              </template>
            </other-button>
          </div>
          <button
              type="button"
              class="btn blockAction__btnDeleteBatchEnd d-flex flex-row align-items-center p-0"
              @click="confirmDeleteBatchEnded"
            >
              <span class="material-icons material-icons-outlined iconBtnDeleteBatchEnd">close</span>
              履歴へ退避
            </button>
          </div>
          <div v-if="tableData.length" class="blockAction__right">
            <div class="sortField">
              <form-select-component
                :options="sortField.filter(field => this.showSerialId || field.value !== 'batchSerialId').map(field => field.value)"
                :customLabel="opt => sortField.find(field => field.value === opt).text"
                v-model="fieldSelected"
                @onChange="onSortParamChange"
              />
            </div>
            <div class="sortType">
              <form-select-component
                :options="sortType.map(field => field.value)"
                :customLabel="opt => sortType.find(field => field.value === opt).text"
                v-model="typeSelected"
                @onChange="onSortParamChange"
              />
            </div>
          </div>
        </div>
      <div class="batchList" ref="batchList" id="batchList">
        <p v-if="!tableData.length" class="batchList__emptyText">登録されていません。</p>
        <div v-for="(batch, index) in tableData"
          :class="{
            'card ml-0 card-batch': true,
            'mt-2': index !== 0,
            'mt-0': index === 0,
            'bg-gray4': (batch.status && batch.status === 5 && (batch.temporaryHolding === 0 || batch.temporaryHolding === 1)) ||
              ( batch.details && batch.details.length > 0 && batch.btnAction.track && !batch.btnAction.finish),
            'bg-white': [0, 1, 4].includes(batch.status) && batch.temporaryHolding === 0,
            'bg-main-8': batch.temporaryHolding === 1,
            'bg-info-16 card-batch-color': (batch.status === 3 || batch.status === 2) && batch.temporaryHolding === 0
          }"
          :style="{ paddingBottom: batch.details && batch.details.length !== 0 ? '16px' : '0' }"
          :key="batch.batchSerialId"
        >
          <div class="card-body d-flex flex-column" :data-batch="batch.batchSerialId">
            <!-- GET PARENT BATCH - START -->
            <div
              :id="`${batch.batchNo}@${batch.batchDetailNo ? batch.batchDetailNo : 0}`"
              :class="[
                {'border-bottom': batch.details && batch.details.length !== 0},
                'parentBatch'
              ]"
            >
              <div class="parentBatch__batchStatus">
                <!-- Batch status -->
                <template v-if="batch.status !== null">
                  <span v-if="batch.temporaryHolding === 1 && batch.status !== 5" class="text-danger">
                    {{ getGenCodeByName(batch.temporaryHolding, 'temporaryHolding') }}
                  </span>
                  <span
                    v-else
                    :class="{'text-info': (batch.status === 3 || batch.status === 2) && batch.temporaryHolding === 0}"
                  >
                    {{ getGenCodeByName(batch.status, 'status') }}
                  </span>
                </template>
              </div>
              <div class="col ml-0 px-0">
                <div class="blockAboveInfo w-100">
                  <div class="blockAboveInfo__on">
                    <div class="blockAboveInfo__on__batchInfo">
                      <!-- Batch Info -->
                      <strong class="batch-info-ellipsis">
                        <span :class="{'batch-name': batch.batchName}">{{ batch.batchName }}</span>
                        {{ batch | displayBatchNo('parent') }}
                      </strong>
                    </div>
                    <div class="blockAboveInfo__on__action">
                      <!-- Display detail button -->
                      <div class="text-info cursor-pointer batch-action"
                      @click="onClickDetail(batch.batchNo, batch.batchDetailNo)"
                      v-if="!batch.details">
                        <i class="material-icons">
                          list
                        </i>
                        明細
                      </div>
                      <!-- Display list batch missing button -->
                      <div class="text-info cursor-pointer ml-2 batch-action"
                        @click="onShowMissList(batch.batchNo, batch.batchDetailNo, 'parent')"
                        v-if="!noWorkTaskType.includes(batch.taskType) && (!batch.details && [2, 3, 4].includes(batch.status) || (batch.missingFlag === 1 && batch.status === 5))"
                      >
                        <span class="icon-list" v-if="[2, 3, 4].includes(batch.status)">
                          <i class="material-icons">
                            list
                          </i>
                          未仕分けリスト
                        </span>
                        <span class="icon-report" v-if="batch.missingFlag === 1 && batch.status === 5">
                          <span class="material-icons">report</span>
                          未仕分けあり
                        </span>
                      </div>
                      <!-- Display delete button -->
                      <div
                        v-if="batch.btnAction.delete"
                        class="text-danger cursor-pointer ml-2 pr-0 batch-action"
                        @click="onChooseDeleteBatchModal(batch)"
                      >
                        <i class="material-icons material-icons-outlined">
                          delete
                        </i>
                        削除
                      </div>
                    </div>
                  </div>
                  <div class="blockAboveInfo__down">
                    <div class="px-0 blockAboveInfo__down__taskType" v-if="getGenCodeByName(batch.taskType, 'taskType')">
                      <!-- Batch Task Type -->
                      タスクタイプ：{{ getGenCodeByName(batch.taskType, 'taskType') }}
                    </div>
                    <div class="px-0 blockAboveInfo__down__memo">
                      <!-- Batch Memo -->
                      <span class="text-nowrap batch-memo">メモ：</span>
                      <!-- Display label memo field -->
                      <editable-label
                        :text="batch.memo"
                        :maxlength=20
                        :id="'memoField_' + batch.batchNo"
                        :ref="'externalEditableLabel' + batch.batchNo"
                        v-on:text-updated="onEditItemName(...arguments, batch)"
                        @edit-mode="(isEdit) => editMode = isEdit"
                        :isVisibleCharactersRemaining="true"
                        :isRequired="false"
                      />
                      <span
                        :id="'editIcon_' + batch.batchNo"
                        class="material-icons edit_icon"
                        @click="onEditLabel(batch.batchNo)"
                      >
                        edit
                      </span>
                    </div>
                  </div>
                </div>
                <div class="border-top mt-1 text-60 small border-gray4 blockBelowInfo">
                  <!-- Batch Serial Id -->
                  <div
                    :class="[
                      batch.status === 2 && batch.temporaryHolding === 0
                        ? 'blockBelowInfo__serialId__displayColumn'
                        : 'blockBelowInfo__serialId__displayRow',
                      'blockBelowInfo__serialId',
                      'mt-2 pl-0 text-nowrap'
                    ]"
                    v-if="showSerialId"
                  >
                    <span class="blockBelowInfo__serialId__key">シリアルID：</span>
                    <span class="blockBelowInfo__serialId__value">{{ batch.batchSerialId }}</span>
                  </div>
                  <!-- Batch Insert Time -->
                  <div
                    v-if="batch.insertTime"
                    :class="[
                      batch.status === 2 && batch.temporaryHolding === 0
                        ? 'blockBelowInfo__insertTime__displayColumn'
                        : 'blockBelowInfo__insertTime__displayRow',
                      'blockBelowInfo__insertTime',
                      'mt-2 px-0'
                    ]"
                  >
                    <span class="blockBelowInfo__insertTime__key">登録：</span>
                    <span class="blockBelowInfo__insertTime__value">{{ batch.insertTime | dateWithoutSeconds }}</span>
                  </div>
                  <!-- Batch Update Time -->
                  <div
                    v-if="batch.updateTime"
                    :class="[
                      batch.status === 2 && batch.temporaryHolding === 0
                        ? 'blockBelowInfo__updateTime__displayColumn'
                        : 'blockBelowInfo__updateTime__displayRow',
                      'blockBelowInfo__updateTime',
                      'mt-2 px-0'
                    ]"
                  >
                    <span class="blockBelowInfo__updateTime__key">更新：</span>
                    <span class="blockBelowInfo__updateTime__value">{{ batch.updateTime | dateWithoutSeconds }}</span>
                  </div>
                </div>
              </div>
              <div class="d-flex">
                <!-- Build Template Action Buttons -->
                <build-batch-action-buttons
                  :batch="batch"
                  :showTemporaryHolding="showTemporaryHolding"
                  @on-alloc="onAlloc"
                  @on-start="onStart"
                  @on-temporary-holding="onTemporaryHolding"
                  @on-download="onClickDownload"
                  @on-finish="onFinish"
                />
              </div>
            </div>
            <!-- GET PARENT BATCH - END -->
            <!-- ---------------------- -->
            <!-- GET CHILDREN BATCH - START -->
            <template v-if="batch.details && batch.details.length > 0">
              <div
                v-for="(itemDetail, idx) in batch.details"
                :key="idx"
                class="border-bottom"
                :id="`${itemDetail.batchNo}@${itemDetail.batchDetailNo ? itemDetail.batchDetailNo : 0}`"
              >
                <div
                  :class="[
                    {
                      'bg-white': [0, 1, 4].includes(itemDetail.status) && itemDetail.temporaryHolding === 0,
                      'bg-main-8 child-batch-margin': itemDetail.temporaryHolding === 1 && itemDetail.status !== 5,
                      'bg-info-16 card-batch-color child-batch-margin': [2, 3].includes(itemDetail.status) && itemDetail.temporaryHolding === 0
                    },
                    'childBatch'
                  ]"
                  :style="{ height: itemDetail['btnAction'].cancelStart || itemDetail['btnAction'].start || itemDetail['btnAction'].temporary_holding || itemDetail['btnAction'].temporary_unHolding ? heightOfChildBatch : 'auto' }"
                >
                <!-- Child batch status -->
                  <div class="childBatch__batchStatus px-0 wrap-text">
                    <span v-if="itemDetail.temporaryHolding === 1 && itemDetail.status !== 5" class="text-danger">
                      {{ getGenCodeByName(itemDetail.temporaryHolding, 'temporaryHolding') }}
                    </span>
                    <span
                      v-else
                      :class="{
                        'text-info': [2, 3].includes(itemDetail.status) && itemDetail.temporaryHolding === 0
                      }"
                    >
                      {{ getGenCodeByName(itemDetail.status, 'status') }}
                    </span>
                  </div>
                  <div class="col d-flex align-items-center ml-0 px-0 justify-content-between">
                    <div class="blockAboveInfo">
                      <div class="px-0 blockAboveInfo__batchNo">
                        <small> {{ itemDetail | displayBatchNo('children') }} </small>
                      </div>
                    </div>
                    <div class="btn-group">
                      <!-- Display detail button on child batch -->
                      <div
                        class="text-info d-flex cursor-pointer batch-action"
                        @click="onClickDetail(batch.batchNo, itemDetail.batchDetailNo)"
                      >
                        <i class="material-icons">
                          list
                        </i>
                        明細
                      </div>
                      <!-- Display list batch missing button on child batch -->
                      <div class="text-info cursor-pointer batch-action"
                        @click="onShowMissList(batch.batchNo, itemDetail.batchDetailNo, 'children')"
                        v-if="[2, 3, 4].includes(itemDetail.status) || (itemDetail.missingFlag === 1 && itemDetail.status === 5)"
                      >
                        <span class="icon-list" v-if="[2, 3, 4].includes(itemDetail.status)">
                          <i class="material-icons">
                            list
                          </i>
                          未仕分けリスト
                        </span>
                        <span class="icon-report" v-if="itemDetail.status === 5 && itemDetail.missingFlag === 1">
                          <span class="material-icons">report</span>
                          未仕分けあり
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    <!-- Build Template Action Buttons -->
                    <build-batch-action-buttons
                      :batch="itemDetail"
                      :showTemporaryHolding="showTemporaryHolding"
                      @on-alloc="onAlloc"
                      @on-start="onStart"
                      @on-temporary-holding="onTemporaryHolding"
                      @on-download="onClickDownload"
                      @on-finish="onFinish"
                    />
                  </div>
                </div>
              </div>
            </template>
            <!-- GET CHILDREN BATCH - END -->
          </div>
        </div>
      </div>
      <search-modal-component
        v-if="tableLabels && tableLabels.length"
        titleModal="検索"
        :tableLabels="tableLabels"
        :query-prameter-value="queryPrameterValue"
        ref="searchModal"
        :table-data="tableData"
        v-on:search="onSearch"
      />
      <b-modal ref="deleteBatchModal" id="delete-batch-modal" @hidden="resetBatchData" centered>
        <div class="d-flex justify-content-center">
          <h5 class="titleHeader mb-0">削除してもよろしいですか？</h5>
        </div>
        <div class="bodyContent">
          <span>実行中のバッチを削除しようとしています。</span> <br/>
          <span>実行中のタスク明細の情報もすべて削除されます。</span> <br/>
          <span>※本操作以外にバッチを『締め』とした後に『履歴へ退避』で履歴を残すこともできます。</span>
        </div>
        <div class="custom-checkbox-label d-flex justify-content-center align-items-center">
          <label class="d-flex justify-content-center align-items-center">
              <b-form-checkbox
                type="checkbox"
                :value="true"
                :unchecked-value="false"
                v-model="allowDeleteBatchProcessing"
              />
              本当に削除してもよろしいでしょうか？
          </label>
        </div>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-around">
            <b-button
              variant="link"
              @click="$bvModal.hide('delete-batch-modal')"
            >
              キャンセル
            </b-button>
            <b-button
              variant="link"
              :disabled="!allowDeleteBatchProcessing"
              @click="onClickDelete(batchData, true, 'delete-batch-modal')"
            >
              OK
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
    <delete-modal-component
      ref="confirmationDeleteModal"
      @on-delete="onDelete"
    />
    <missing-items-modal
      ref="missing-items-modal"
      v-model="isShowMissingModal"
      :isShowBatchDetailNo ="isShowBatchDetailNo"
    />
  </div>
</template>
<script lang="js">
import AppConstants from '../../constants/app.constants'
import BatchControlButton from '../custom-components/BatchControlButton.vue'
import BuildBatchActionButtons from '../custom-components/BuildBatchActionButtons.vue'
import SearchModalComponent from '../../components/custom-components/SearchModalComponent.vue'
import DetailModalComponent from '../../components/custom-components/DetailModalComponent.vue'
import DeleteModalComponent from '../../components/custom-components/DeleteModalComponent.vue'
import * as moment from 'moment'
import Loading from 'vue-loading-overlay'
import { saveAs } from 'file-saver'
import HTTPClient from './../../common/http-client'
import ErrorCdMsgConstants from '../../constants/error-cd-msg.constants'
import CommonUtils from '../../mixins/commonUtils'
import CsvExportButton from '../custom-components/CsvExportButton'
import OtherButton from '../custom-components/OtherButton'
import FlashMessage from '../../common/flash-message.component.js'
import EditableLabel from '../custom-components/EditableLabel'
import RouterUtils from '../../_helpers/router.util'
import { mapActions, mapState, mapGetters } from 'vuex'
import BatchTaskUtils from '../../_helpers/batch-task.util'
import MissingItemsModal from '../modal/MissingItemsModal.vue'
import FormSelectComponent from '../custom-components/FormSelectComponent.vue'
import { FieldDataType } from '../../enums/field-data-type.enums'
import VueScrollTo from 'vue-scrollto'
import { decodeFilenameMixin } from '../../mixins/decodeFileName.js'
const API_END_POINT = 'batch'
const STATUS = {
  noProcessed: 0,
  allocated: 1,
  started: 2,
  processing: 3,
  completed: 4,
  end: 5
}
const SORT_TYPE_ASC_VALUE = ' '
const BATCH_SERIAL_ID = 'batchSerialId'
const BATCH_PARENT = 'parent'
const BATCH_CHILDREN = 'children'
export default {
  components: {
    DetailModalComponent,
    BatchControlButton,
    Loading,
    SearchModalComponent,
    CsvExportButton,
    OtherButton,
    BuildBatchActionButtons,
    EditableLabel,
    DeleteModalComponent,
    MissingItemsModal,
    FormSelectComponent,
    FieldDataType
  },
  mixins: [CommonUtils, decodeFilenameMixin],
  data() {
    return {
      isLoading: false,
      tableNo: 'trBatch',
      tableLabels: [],
      tableData: [],
      removeKeys: [],
      isRemoveCheck: false,
      showTemporaryHolding: true,
      // eslint-disable-next-line no-array-constructor
      sortValueKey: new Array(),
      queryPrameterValue: {},
      checkConfirm: null,
      totalRecords: 0,
      isCheckValueSearched: false,
      offset: 0,
      limitData: this.currentPageParam(),
      searchFieldNames: [],
      editMode: false,
      allowDeleteBatchProcessing: false,
      batchData: {},
      noWorkTaskType: [],
      deleteBatchConfirm: false,
      fieldSelected: 'status',
      typeSelected: SORT_TYPE_ASC_VALUE,
      sortParams: '',
      batchListScrollPosition: 0,
      sortField: [
        { value: 'status', text: 'ステータスで並べ替え' },
        { value: 'batchSerialId', text: 'シリアルIDで並べ替え' },
        { value: 'batchNo', text: 'バッチ番号で並べ替え' },
        { value: 'batchName', text: 'バッチ名で並べ替え' },
        { value: 'taskType', text: 'タスクタイプで並べ替え' },
        { value: 'insertTime', text: '登録日時で並べ替え' },
        { value: 'updateTime', text: '更新日時で並べ替え' }
      ],
      sortType: [
        { value: SORT_TYPE_ASC_VALUE, text: '昇順' },
        { value: '-', text: '降順' }
      ],
      isShowMissingModal: false,
      processedBatchNo: null,
      processedBatchDetailNo: null,
      heightOfChildBatch: 'auto',
      totalRecordsLimitInDb: 0,
      isShowBatchDetailNo: false,
      showSerialId: false
    }
  },
  filters: {
    dateWithoutSeconds(data) {
      return moment(data).format(AppConstants.APP_MONTH_DATE_TIME_WITHOUT_SECONDS)
    },
    formatValueData(value, sortVal, keyName = null) {
      let reslutVal = value
      if (sortVal.keyName === keyName) {
        reslutVal = sortVal.mstGenLabel[value]
      }
      return reslutVal
    },
    displayBatchNo(batch, batchType) {
      const batchNo = batch.batchNo || ''
      const batchDetailNo = batch.batchDetailNo || ''
      const separator = batchNo && batchDetailNo ? '-' : ''
      return batchType === BATCH_PARENT
        ? `${batchNo}`
        : `${batchNo}${separator}${batchDetailNo}`
    }
  },
  beforeUpdate() {
    this.$refs.batchList.scrollTop = this.batchListScrollPosition
    if (this.$refs.infiniteLoading) {
      this.isReloaded = false
      this.$refs.infiniteLoading.stateChanger.reset()
    }
  },
  beforeCreate() {
    // Initialize the query object into localstorage according
    // to the current routeName with the query string being empty
    RouterUtils.initQueryObjectInStorage(this.$route.name, '')
  },
  beforeDestroy() {
    const batchListScroller = this.$refs.batchList
    batchListScroller.removeEventListener('scroll', () => {})
    window.removeEventListener('resize', this.onResize)
  },
  created() {
    this.fetchRequest(this.currentUrlQueryStr())
      .then(response => {
        const data = response.data
        this.tableLabels = data.mstTableManagement
        this.totalRecordsLimitInDb = data.totalRecordsLimit
        this.tableData = data[this.tableNo]
        this.noWorkTaskType = data.noWorkTaskType
        this.totalRecords = data.totalRecords
        this.showTemporaryHolding = data.showTemporaryHolding === 'show'
        this.tableLabels.map(element => { element.displayFlag = 1 })
        for (let key in this.tableLabels) {
          let dataType = this.tableLabels[key]['dataType']
          let keyName = this.tableLabels[key]['isItemNo']
          let mstGen = {}
          if (this.tableLabels[key].mstGenCode) {
            this.tableLabels[key].mstGenCode.forEach(gen => {
              mstGen[gen.code] = gen.name
            })
          }
          this.sortValueKey.push({
            dataType,
            keyName: keyName,
            mstGenLabel: mstGen
          })
        }
        this.initialize()
        this.initActionStatus(data[this.tableNo])
      })
      .catch(err => {
        console.log(err)
      })
  },
  mounted() {
    const batchListScroller = this.$refs.batchList
    batchListScroller.addEventListener('scroll', () => {
      this.batchListScrollPosition = batchListScroller.scrollTop
    })
    window.addEventListener('resize', this.onResize)
  },
  updated() {
    this.heightOfChildBatch = this.getHeightParentBatch()
  },
  computed: {
    /**
     * レコード総数表示を処理する。
     *【追加上限がある】場合、追加上限表示を文末に追加。
     * @returns {string} レコード総数表示
     */
    displayTotalRecords: function() {
      const totalRecordsStr = `${this.totalRecords}件`
      const totalRecordsLimitInDbStr = !this.isCheckValueSearched && this.totalRecordsLimitInDb ? `（${this.totalRecordsLimitInDb}件まで登録可能）` : ''
      return totalRecordsStr + totalRecordsLimitInDbStr
    },
    ...mapState('socket', ['messages', 'isEnabled']),
    ...mapGetters('settingWizardStore', ['getMenuStatus'])
  },
  watch: {
    async messages(newValue, oldValue) {
      if (!Array.isArray(newValue)) {
        return
      }
      const isTaskOrBatchScreen = newValue.includes(AppConstants.BATCH_SOCKET) || newValue.includes(AppConstants.TASK_SOCKET)
      if (isTaskOrBatchScreen && this.isShowMissingModal) {
        // 新しい欠損データを取得する。
        await this.fetchMissingData()
      }
      if (newValue.includes(AppConstants.BATCH_SOCKET) || this.checkSocketMsgToReloadOtherPage(newValue) || this.checkToReloadTableWithTotalRecordLimit(newValue)) {
        this.setMessages([])
        await this.$_refleshTableData()
      }
    },
    '$store.state.reconnectedFlag': async function(newValue) {
      if (newValue) {
        await this.$_refleshTableData()
      }
    },
    getMenuStatus() {
      this.onResize()
    }
  },
  methods: {
    ...mapActions('socket', ['setMessages']),
    ...mapGetters('socket', ['isSocketEnabled']),
    handleScrollToItem() {
      // バッチ リストの位置が更新され、スクロールするようにレンダリングされるのを待ちます。
      setTimeout(() => {
        const elementScrollTo = document.getElementById(`${this.processedBatchNo}@${!this.processedBatchDetailNo ? 0 : this.processedBatchDetailNo}`)
        if (!elementScrollTo || !this.processedBatchNo) {
          return
        }
        VueScrollTo.scrollTo(elementScrollTo, 100, {offset: 0, easing: 'linear', container: '#batchList'})
        // スクロール後にバッチのシリアルID とバッチの詳細番号をリセットします。
        this.processedBatchNo = null
        this.processedBatchDetailNo = null
      }, 100)
    },
    checkSocketMsgToReloadOtherPage(newMsg) {
      return AppConstants.ENTITIES_TO_RELOAD_PAGE[this.$route.name] && AppConstants.ENTITIES_TO_RELOAD_PAGE[this.$route.name].some(s => newMsg.indexOf(s) >= 0)
    },
    /**
     * ソケットメッセージが開発者設定更新の通知で、当テーブルが対象（追加上限ある）かどうかをチェック。
     * @param   {Array}   newMsg ソケットメッセージ
     * @returns {boolean}        当テーブルが対象の場合はtrue、そうでない場合はfalse
     */
    checkToReloadTableWithTotalRecordLimit(newMsg) {
      if (newMsg && newMsg.includes(AppConstants.DEV_SETTING_SOCKET)) {
        return AppConstants.ENTITIES_TO_RELOAD_PAGE_WHEN_DEV_SETTING_CHANGED.includes(AppConstants.BATCH_SOCKET)
      }
      return false
    },
    formatedValue(key) {
      // if (key.startsWith('before_') || key.startsWith('after_')) {
      //   return this.tableLabels.filter(tLabel => tLabel.isItemNo === key.split('_')[1])[0].itemName
      // } else {
      //   return this.tableLabels.filter(tLabel => tLabel.isItemNo === key)[0].itemName
      // }
    },
    searchBatch(param) {
      // this.fetchRequest(param)
      //   .then(response => {
      //     this.tableData = response.data[this.tableNo]
      //     this.totalRecords = response.data.totalRecords
      //     RouterUtils.replaceUrlStr(param)
      //     this.initActionStatus()
      //   })
      //   .catch(err => {
      //     console.log(err)
      //     FlashMessage.getInstance().showErrorMessage(err.response.data.errMsg)
      //   })
    },
    onDeleteTaggedField(key) {
      // this.searchFieldNames.splice(this.searchFieldNames.indexOf(key), 1)
      // if (Array.isArray(this.queryPrameterValue[key])) {
      //   this.queryPrameterValue[key] = []
      // } else if (key.startsWith('before_') || key.startsWith('after_')) {
      //   this.queryPrameterValue[key] = null
      //   if (key.startsWith('before_')) {
      //     this.queryPrameterValue[key.replace('before_', 'after_')] = null
      //   } else {
      //     this.queryPrameterValue[key.replace('after_', 'before_')] = null
      //   }
      // } else {
      //   this.queryPrameterValue[key] = null
      // }
      // this.searchBatch(this.$_generateQueryString())
      // this.isEmptyDataSearch()
    },
    isEmptyDataSearch() {
      // (Object.values(this.queryPrameterValue).every(
      //   x => x === null || x === '' || x.length === 0
      // ))
      //   ? (this.isCheckValueSearched = false)
      //   : (this.isCheckValueSearched = true)
    },
    /**
     * バッチ制御とローカル ストレージの並べ替え基準を返す
     */
    getParamForSortBatch() {
      let fieldSortParam = this.fieldSelected
      let typeSortParam = this.getSelectedSortType()
      localStorage.setItem('batchSort', JSON.stringify([typeSortParam, this.fieldSelected]))
      return `${typeSortParam}${fieldSortParam}`
    },
    /**
     * トリム後に選択された並べ替えタイプを取得する
     */
    getSelectedSortType() {
      return this.typeSelected.trim()
    },
    /**
     * ユーザーが並べ替え基準を変更すると、テーブル データを更新します
     */
    async onSortParamChange() {
      try {
        this.isLoading = true
        await this.$_refleshTableData()
      } finally {
        this.isLoading = false
      }
    },
    initActionStatus(tableData) {
      const progressStatusParent = this.buildProgressStatus(tableData)
      this.checkAllBatchStatusDuringOperation(tableData)
      tableData.forEach(batch => {
        if (!batch.details) {
          batch['btnAction'] = this.$_btnActionStatus(
            batch.status,
            batch.batchDetailNo === 1,
            progressStatusParent[batch.batchNo],
            batch,
            batch.isVisible
          )
        } else {
          batch['btnAction'] = this.buildParentActionBtnStatus(batch)
          batch.details.forEach(itemDetail => {
            itemDetail['btnAction'] = this.buildChildrenActionBtnStatus(itemDetail, batch.details, itemDetail.isVisible)
          })
        }
      })
    },
    checkAllBatchStatusDuringOperation(batches) {
      if (!batches) {
        return
      }
      let batchFlatArray = this.getBatchFlatArray(batches)
      // Finds which batch has a status starting or in process and is not holding from the flat batch array
      const existedProcessingBatch = batchFlatArray
        .some(batch =>
          (batch.status === STATUS.started || batch.status === STATUS.processing) &&
          !batch.temporaryHolding
        )
      // Finds which batch has a status completed and is not holding from the flat batch array
      // and returns array of batch_no
      const completedBatchNos = batchFlatArray
        .filter(batchIsCompleted => batchIsCompleted.status === STATUS.completed && !batchIsCompleted.temporaryHolding)
        .map(({batchNo}) => batchNo)

      for (let batch of batchFlatArray) {
        // Hide start and unHold buttons
        if (existedProcessingBatch) {
          batch.isVisible = false
          continue
        }
        // Hide start and unHold buttons when other batchNo
        if (completedBatchNos && completedBatchNos.some(batchNo => batchNo !== batch.batchNo)) {
          batch.isVisible = false
          continue
        }
        batch.isVisible = true
      }
    },
    getBatchFlatArray (batches) {
      if (!batches) {
        return []
      }
      let batchFlatArray = []
      batches.forEach(batch => {
        // Because when the batch has details, the status and temporary holding are null
        if (batch.details) {
          batch.details.forEach(detail => {
            batchFlatArray.push(detail)
          })
        } else {
          batchFlatArray.push(batch)
        }
      })
      return batchFlatArray
    },
    buildChildrenActionBtnStatus(child, children, isVisibleButtonByBatches) {
      let activeButtons = {
        start: false,
        cancelStart: false,
        temporary_holding: false,
        temporary_unHolding: false
      }
      const isBatchHoldingAndBatchStatusEnd = child.temporaryHolding === 1 && child.status === STATUS.end
      const isBatchHoldingAndListBatchIsWorking = child.temporaryHolding === 1 && !isVisibleButtonByBatches

      // When the child is holding and there exists another batch in the following status (start, processing, completed)
      // Or
      // When the child is holding and status is ended
      if (isBatchHoldingAndBatchStatusEnd || isBatchHoldingAndListBatchIsWorking) {
        activeButtons.temporary_unHolding = false
        return activeButtons
      }
      // When the child is holding and status is not end
      if (child.temporaryHolding === 1 && child.status !== STATUS.end) {
        activeButtons.temporary_unHolding = true
        return activeButtons
      }
      switch (child.status) {
        case 1:
          const filterChildrenStatus = children.filter(el => el.status === 2 || el.status === 3)
          if ((filterChildrenStatus.length === 0 || filterChildrenStatus.every(el => el.temporaryHolding === 1)) && isVisibleButtonByBatches) {
            activeButtons.start = true
          }
          break
        case 2:
          activeButtons.cancelStart = true
          activeButtons.temporary_holding = true
          break
        case 3:
        case 4:
          activeButtons.temporary_holding = true
          break
        default:
          break
      }
      return activeButtons
    },
    buildProgressStatus(datas) {
      return datas.reduce((result, current, index) => {
        if (result[current.batchNo]) {
          result[current.batchNo][current.status] = true
        } else {
          result[current.batchNo] = {}
          if (current.status) {
            result[current.batchNo][current.status] = true
          }
        }
        return result
      }, {})
    },
    $_btnActionStatus(status, isRootBatch, progress, item, isVisibleButtonByBatches) {
      let activeButtons = {
        alloc: status === STATUS.noProcessed && this.noWorkTaskType.indexOf(item.taskType) === -1,
        start: false,
        cancelStart: false,
        track: false,
        finish: false,
        delete: true,
        temporary_holding: false,
        temporary_unHolding: false
      }
      if (!status) return activeButtons
      // 終了を押した場合の状態
      if (progress[STATUS.end]) {
        activeButtons.track = isRootBatch
        activeButtons.delete = false
        return activeButtons
      }
      let isEnabled =
        progress[STATUS.started] ||
        progress[STATUS.processing] ||
        progress[STATUS.completed] ||
        false
      let isEnableDelete =
        progress[STATUS.allocated] ||
        progress[STATUS.noProcessed] ||
        isEnabled
      // 割当済1 ~ 完了済4までの状態
      activeButtons.track = isRootBatch && isEnabled
      activeButtons.finish = isRootBatch && isEnabled
      activeButtons.delete = isRootBatch && isEnableDelete

      if ((status !== STATUS.processing && status !== STATUS.completed && this.noWorkTaskType.indexOf(item.taskType) === -1) && !item.temporaryHolding) {
        // Display cancel start button when current batch is 2
        // and there exists at least status (start, completed, processing)
        if (status === STATUS.started && !isVisibleButtonByBatches) { // Cancel Start
          activeButtons.cancelStart = true
          activeButtons.start = false
        } else if (isVisibleButtonByBatches) { // Start
        // Display start button when current batch is 2
        // and there is no batch with status (start, completed, processing)
          activeButtons.cancelStart = false
          activeButtons.start = true
        }
      }
      // Display unHold button when current batch is holding
      // and there is no batch with status (start, completed, processing)
      activeButtons.temporary_unHolding = isEnabled && item.temporaryHolding === 1 && isVisibleButtonByBatches // Un-hold
      // Display hold button when current batch is not hold
      // and there exists at least status (start, completed, processing)
      activeButtons.temporary_holding = isEnabled && !item.temporaryHolding // Hold
      return activeButtons
    },
    buildParentActionBtnStatus(batch) {
      let activeButtons = {
        delete: true,
        track: false,
        finish: false,
        color: false,
        temporary_holding: false
      }
      if (this.checkParentBatchBeHeld(batch.details)) {
        activeButtons.temporary_holding = true
      }
      if (this.checkListWithSameStatus(STATUS.allocated, batch.details)) {
        // When all sub batches have status equal to 1
        return activeButtons
      }
      if (this.checkListWithSameStatus(STATUS.completed, batch.details)) {
        // When all sub batches have status equal to 4
        activeButtons.track = true
        activeButtons.finish = true
        activeButtons.color = true // if color true then build blue background
        return activeButtons
      }
      if (this.checkListWithSameStatus(STATUS.end, batch.details)) {
        // When all sub batches have status equal to 5
        activeButtons.delete = false
        activeButtons.track = true
        return activeButtons
      }
      // The remaining case
      activeButtons.track = true
      activeButtons.finish = true
      activeButtons.color = false // if color true then build white background
      return activeButtons
    },
    checkListWithSameStatus(status, array) {
      if (!array) {
        return false
      }
      return array.every(el => el['status'] === status)
    },
    /**
     * 親バッチにホールドボタンを表示する場合にチェック
     * ステータスが 2、3、4 のサブバッチが少なくとも 1 つあり、保持されていない場合に有効にします
     */
    checkParentBatchBeHeld(trBatchDetails) {
      if (!trBatchDetails) {
        return false
      }
      let res = trBatchDetails.some(batchDetail => batchDetail.temporaryHolding === 0 &&
       (batchDetail.status === 2 || batchDetail.status === 3 || batchDetail.status === 4))
      return res
    },
    onClickDetail(batchNo, batchDetailNo) {
      const queryTaskStatement = { batchNo, batchDetailNo, showBatchDetails: true }
      BatchTaskUtils.goToTaskDetailPage(queryTaskStatement)
    },
    showModalSearch() {
      // this.$refs.searchModal.showModal()
    },
    handleBeforeAfterFields(keyPrefix, otherKeyPrefix, queryParameterKeys, key) {
      // if (key.startsWith(keyPrefix)) {
      //   let otherField = key.replace(keyPrefix, otherKeyPrefix)
      //   let otherFieldValue = this.queryPrameterValue[otherField]
      //   const otherIndex = queryParameterKeys.indexOf(otherField)
      //   const currentIndex = queryParameterKeys.indexOf(key)
      //   if ((otherFieldValue === null || otherFieldValue === '') || (otherIndex > currentIndex)) {
      //     return true
      //   }
      //   return false
      // }
    },
    onSearch(data) {
      // this.queryPrameterValue = {...data}
      // this.buildSearchFieldNames(this.queryPrameterValue)
      // this.$refs.batchList.scrollTop = 0
      // this.offset = 0
      // this.limitData = {}
      // this.isEmptyDataSearch()
      // this.searchBatch(this.$_generateQueryString())
    },
    buildSearchFieldNames(queryPrameterValue) {
      // this.searchFieldNames = []
      // const queryParameterKeys = Object.keys(queryPrameterValue)
      // for (const [key, value] of Object.entries(queryPrameterValue)) {
      //   if ((value === null || value === '' || value.length === 0)) {
      //     continue
      //   }
      //   if (key.startsWith('before_') || key.startsWith('after_')) {
      //     if (this.handleBeforeAfterFields('before_', 'after_', queryParameterKeys, key)) {
      //       this.searchFieldNames.push(key)
      //     } else if (this.handleBeforeAfterFields('after_', 'before_', queryParameterKeys, key)) {
      //       this.searchFieldNames.push(key)
      //     }
      //   } else {
      //     this.searchFieldNames.push(key)
      //   }
      // }
    },
    // URLの置換処理
    replaceUrlStr(replaceStr) {
      let replaceUrl = location.href.replace(/[?].+/, '')
      history.replaceState('', '', replaceUrl + replaceStr)
    },
    onChooseDeleteBatchModal(batch) {
      let status = batch.status
      this.deleteBatchConfirm = false
      if (batch.details && batch.details.length > 0) {
        const batchStatusProcessing = batch.details.find(detail => [STATUS.started, STATUS.processing, STATUS.completed].includes(detail.status))
        batchStatusProcessing ? status = batchStatusProcessing.status : status = batch.details[0].status
      }
      if ([2, 3, 4].includes(status)) {
        this.showDeleteModalBatchProcessing(batch)
        return
      }
      this.$refs.confirmationDeleteModal.show(batch)
    },
    showDeleteModalBatchProcessing(batch) {
      this.batchData = {...batch}
      this.$refs.deleteBatchModal.show()
    },
    resetBatchData() {
      this.batchData = {}
      this.allowDeleteBatchProcessing = false
      this.handleHideModal()
    },
    handleHideModal() {
      if (!this.deleteBatchConfirm) {
        return FlashMessage.getInstance().showSuccessMessage('削除をキャンセルしました。')
      }
    },
    onDelete(batch, removeConfirm, id) {
      this.onClickDelete(batch, removeConfirm, id)
    },
    async onClickDelete(deleteObj, removeConfirm, id) {
      this.deleteBatchConfirm = removeConfirm
      this.$bvModal.hide(id)
      if (!removeConfirm) {
        return this.handleHideModal()
      }
      try {
        this.isLoading = true
        await this.sendDeleteRequest(this.getBatchByDetails(deleteObj))
        FlashMessage.getInstance().showSuccessMessage('削除完了。')
      } catch (error) {
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
        this.isLoading = false
      }
      this.isLoading = false
      this.checkAndRefreshTableDataManually()
    },
    async $_refleshTableData() {
      try {
        const response = await this.fetchRequest(this.currentUrlQueryStr())
        const data = response.data
        this.tableData = data[this.tableNo]
        this.totalRecords = data.totalRecords
        this.tableLabels = data.mstTableManagement
        this.totalRecordsLimitInDb = data.totalRecordsLimit
        this.initActionStatus(data[this.tableNo])
        this.handleScrollToItem()
      } catch (error) {
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
      }
    },
    async checkAndRefreshTableDataManually() {
      if (!this.isSocketEnabled()) {
        await this.$_refleshTableData()
      }
    },
    currentUrlQueryStr() {
      return RouterUtils.getQueryString(this.$route.name)
    },
    /**
     * 現在のページパラメータ取得
     * -- offset データの取得開始位置
     * -- limit  データの取得終点位置
     */
    currentPageParam() {
      var regex = /offset=\d+|limit=\d+/g
      var pageParams = location.href.match(regex)
      var param = {}
      if (pageParams && pageParams.length) {
        pageParams.forEach(pparam => {
          var keyPair = pparam.split('=')
          param[keyPair[0]] = parseInt(keyPair[1])
        })
      }
      return param
    },
    /** =========================
     * リクエストメソッド
     =========================== */
    async fetchRequest(querystr = '') {
      // return HTTPClient.getInstance().httpMock.get(`/work/batch${this.setRemitQuery(querystr)}`)
      if (this.totalRecords || !localStorage.getItem('batchSort')) {
        querystr = `?isCreateParentBatch=true&sort=${this.getParamForSortBatch()}`
        this.sortParams = querystr
      } else {
        let batchSorts = JSON.parse(localStorage.getItem('batchSort'))
        this.typeSelected = batchSorts[0] || SORT_TYPE_ASC_VALUE
        this.fieldSelected = batchSorts[1]
        this.sortParams = this.currentUrlQueryStr()
        querystr = this.sortParams
      }
      RouterUtils.updateQueryObjectToStorage(this.$route.name, querystr)
      RouterUtils.replaceUrlStr(querystr || '')
      const res = await this.$axios.get(
        `/work/${API_END_POINT}${querystr}`
      )
      if (res && res.data) {
        this.showSerialId = res.data.showSerialId
      }
      if (this.fieldSelected === BATCH_SERIAL_ID && !this.showSerialId) {
        // 選択フィールドのデフォルト値を更新する
        this.fieldSelected = this.sortField[0].value
        querystr = `?isCreateParentBatch=true&sort=${this.getParamForSortBatch()}`
        this.sortParams = querystr
        RouterUtils.updateQueryObjectToStorage(this.$route.name, querystr)
        RouterUtils.replaceUrlStr(querystr || '')
      }
      return res
    },
    async updateRequest(request) {
      const res = await this.$axios.put(`/work/${API_END_POINT}`, {
        [this.tableNo]: request
      })
      return res
    },
    updateMemoRequest(request) {
      return this.$axios.put(`/work/${API_END_POINT}/func/batch/update-memo`, request)
    },
    async sendDeleteRequest(deleteObj) {
      await this.$axios.delete(`/work/${API_END_POINT}`, {
        data: { trBatch: [deleteObj] }
      })
    },
    /**
     * タスク実績ファイル自動出力
     */
    async outputResultFile() {
      const res = await this.$axios.post('/func/task/output-result-file').catch(err => {
        console.log(err)
        this.isLoading = false
        FlashMessage.getInstance().parseAndShowErrorMessage(err)
        throw new Error()
      })
      return res
    },
    /**
     * タスク履歴退避
     */
    async backupToHistory() {
      const res = await this.$axios.post('/func/task/backup-to-taskhst').catch(err => {
        console.log(err)
        this.isLoading = false
        FlashMessage.getInstance().parseAndShowErrorMessage(err)
        throw new Error()
      })
      return res
    },
    /**
     * 自動実績出力＆タスク履歴退避前にタスク検証
     */
    async taskValidateBeforeBackupToTaskHst() {
      const res = await this.$axios.get('func/task/validate-before-backup-to-taskhst').catch(err => {
        FlashMessage.getInstance().parseAndShowErrorMessage(err)
        throw new Error()
      })
      return res
    },
    async onTemporaryHolding(trBatch) {
      if (trBatch['details']) {
        await this.temporaryHoldingByBatchNo(trBatch['batchNo'])
      } else {
        await this.temporaryHoldingABatch(trBatch)
      }
    },
    async temporaryHoldingABatch(trBatch) {
      this.isLoading = true
      try {
        if (trBatch.temporaryHolding === 0) {
          // 一時保留確認
          let queryParam = '?'
          for (let key in trBatch) {
            if (typeof trBatch[key] === 'object') continue
            queryParam += `&trBatch.${key}=${RouterUtils.encodedUrlParam(trBatch[key])}`
          }
          queryParam = queryParam.replace('?&', '?')
          const result = await this.$axios.get(
            '/func/batch/temporary-holding-on', {params: RouterUtils.parseQueryToObject(queryParam)}
          )
          if (result.data.msg === 'NG') {
            this.isLoading = false
            return FlashMessage.getInstance().showErrorMsgWithErrorCode(
              ErrorCdMsgConstants.FUNC_BATCH_TEMPORARY_HOLDING_ON_TASK_PROCESSING_ERR_CD,
              ErrorCdMsgConstants.FUNC_BATCH_TEMPORARY_HOLDING_ON_TASK_PROCESSING_ERR_MSG
            )
          }
        }
        // 一時保留・一時保留解除処理実行
        let apiURL = '/func/batch/temporary-holding-on'
        let message = '一時保留完了。'
        if (trBatch.temporaryHolding === 1) {
          apiURL = '/func/batch/temporary-holding-off'
          message = '一時保留解除完了。'
        }
        await this.$axios.put(apiURL, { trBatch: trBatch })
        FlashMessage.getInstance().showSuccessMessage(message)
      } catch (error) {
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
        this.isLoading = false
      }
      this.isLoading = false
      await this.checkAndRefreshTableDataManually()
      this.processedBatchNo = trBatch.batchNo
      this.processedBatchDetailNo = trBatch.batchDetailNo
    },
    async temporaryHoldingByBatchNo(batchNo) {
      this.isLoading = true
      try {
        let apiURL = '/func/batch/temporary-holding-on'
        let message = '一時保留完了。'
        const result = await this.$axios.put(apiURL, { batchNo: batchNo })
        if (result.data.msg === 'NG') {
          this.isLoading = false
          await this.$_refleshTableData()
          return FlashMessage.getInstance().showErrorMsgWithErrorCode(
            ErrorCdMsgConstants.FUNC_PARENT_BATCH_TEMPORARY_HOLDING_ON_TASK_PROCESSING_ERR_CD,
            ErrorCdMsgConstants.FUNC_PARENT_BATCH_TEMPORARY_HOLDING_ON_TASK_PROCESSING_ERR_MSG
          )
        }
        await this.$_refleshTableData()
        FlashMessage.getInstance().showSuccessMessage(message)
      } catch (error) {
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
      }
      this.processedBatchNo = batchNo
      this.processedBatchDetailNo = null
      this.isLoading = false
    },
    async onAlloc(trBatch) {
      this.isLoading = true
      try {
        await this.$axios.put('/func/task/assign', {
          trBatch
        })
        FlashMessage.getInstance().showSuccessMessage('割当完了。')
      } catch (error) {
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
        this.isLoading = false
      }
      this.isLoading = false
      await this.checkAndRefreshTableDataManually()
      this.processedBatchNo = trBatch.batchNo
      this.processedBatchDetailNo = trBatch.batchDetailNo
    },
    async onStart(trBatch) {
      this.isLoading = true
      try {
        let apiURL = '/func/batch/start'
        let message = '実行開始完了。'
        // TODO: status = 2  is cancel ?
        if (trBatch.status === 2) {
          apiURL = '/func/batch/cancel'
          message = '実行取消完了。'
        }
        await this.$axios.put(apiURL, { trBatch: trBatch })
        FlashMessage.getInstance().showSuccessMessage(message)
      } catch (error) {
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
        this.isLoading = false
      }
      this.isLoading = false
      await this.checkAndRefreshTableDataManually()
      this.processedBatchNo = trBatch.batchNo
      this.processedBatchDetailNo = trBatch.batchDetailNo
    },
    async onClickDownload(trBatch) {
      try {
        this.isLoading = true
        const response = await HTTPClient.getInstance().httpBlob.post('/func/task/dl', {
          batchNo: trBatch.batchNo
        })
        const blob = new Blob([response.data], {
          type: 'text/csv'
        })
        // レスポンスヘッダからファイル名を取得します
        const contentDisposition = response.headers['content-disposition']
        const filename = this.decodeFileName(contentDisposition)
        if (filename === 'ファイル名不明') {
          // バックエンドから返ったきたCSVファイルnullだった場合
          FlashMessage.getInstance().showErrorMessage('ファイルをダウンロードしようとしましたが、データがないかマッピングが未登録でした。該当するタスク明細が存在するか、CSV実績データマッピング設定画面を確認してください。')
          this.isLoading = false
          return
        }
        await this.$_refleshTableData()
        // ダウンロードします
        saveAs(blob, `${filename}.csv`)
      } catch (error) {
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
      } finally {
        this.isLoading = false
      }
    },
    async onFinish(trBatch) {
      try {
        let queryParam = '?'
        const filteredBatch = this.getBatchByDetails(trBatch)
        for (let key in filteredBatch) {
          if (typeof trBatch[key] === 'object') continue
          queryParam += `&trBatch.${key}=${RouterUtils.encodedUrlParam(trBatch[key])}`
        }
        queryParam = queryParam.replace('?&', '?')
        const result = await this.$axios.get('/func/batch/end', {params: RouterUtils.parseQueryToObject(queryParam)})
        if (result.data.msg === 'NG') {
          const isConfirm = confirm(
            '未仕分けの商品が残っていますが、締めますか？'
          )
          if (!isConfirm) {
            return FlashMessage.getInstance().showSuccessMessage('バッチの終了処理をキャンセル。')
          }
        }
        this.isLoading = true
        // バッチの強制終了
        await this.$axios.put('/func/batch/end', { trBatch: filteredBatch })
        FlashMessage.getInstance().showSuccessMessage('バッチを終了しました。')
      } catch (error) {
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
        this.isLoading = false
      }
      this.isLoading = false
      await this.checkAndRefreshTableDataManually()
      this.processedBatchNo = trBatch.batchNo
      this.processedBatchDetailNo = trBatch.batchDetailNo
    },
    initialize() {
      for (let key in this.tableLabels) {
        let dataType = this.tableLabels[key]['dataType']
        let keyName = this.tableLabels[key]['isItemNo']
        /**
         * 初期データセット
         */
        // eslint-disable-next-line no-unused-vars
        var routeQuery = this.$route.query[keyName]
        switch (dataType) {
          case FieldDataType.STRING:
            this.$set(
              this.queryPrameterValue,
              `${keyName}`,
              routeQuery ? routeQuery.toString() : null
            )
            break
          case FieldDataType.NUMBER:
            let numberQuerys = routeQuery || []
            if (!Array.isArray(numberQuerys)) {
              numberQuerys = [numberQuerys]
            }
            this.$set(
              this.queryPrameterValue,
              `before_${keyName}`,
              parseInt(numberQuerys[0]) || null
            )
            this.$set(
              this.queryPrameterValue,
              `after_${keyName}`,
              parseInt(numberQuerys[1]) || null
            )
            break
          case FieldDataType.LIST:
            let listQuerys = routeQuery || []
            if (!Array.isArray(listQuerys)) {
              listQuerys = [listQuerys]
            }
            let result = listQuerys.map(function (x) {
              return parseInt(x)
            })
            this.$set(this.queryPrameterValue, keyName, result)
            break
          case FieldDataType.DATE:
            var dateQueryStr = routeQuery && routeQuery[0]
              ? routeQuery[0].replace(' 00:00:00', '')
              : null
            this.$set(this.queryPrameterValue, `${keyName}`, dateQueryStr)
            break
        }
      }
      this.buildSearchFieldNames(this.queryPrameterValue)
      this.isEmptyDataSearch()
    },
    /** ============================================================================
     * URLに付与するリクエストパラメーターを作成
     * @reslutsIsArray 戻り値を配列にして返す(falseだとStringで返る)
     ============================================================================ */
    $_generateQueryString(reslutsIsArray = false) {
      var queryStrings = []
      this.sortValueKey.forEach(sortRow => {
        let value = this.queryPrameterValue[sortRow.keyName]
        switch (sortRow.dataType) {
          case FieldDataType.STRING:
            if (value) {
              queryStrings.push(
                `${sortRow.keyName}=${encodeURIComponent(value)}`
              )
            }
            break
          case FieldDataType.NUMBER:
            let before = this.queryPrameterValue[`before_${sortRow.keyName}`]
            let after = this.queryPrameterValue[`after_${sortRow.keyName}`]
            if (before && after) {
              queryStrings.push(
                `${sortRow.keyName}=${before}&${sortRow.keyName}=${after}`
              )
            } else {
              if (before) queryStrings.push(`${sortRow.keyName}=${before}`)
              if (after) queryStrings.push(`${sortRow.keyName}=${after}`)
            }
            break
          case FieldDataType.LIST:
            Object.keys(value || {}).forEach(listObjectKey => {
              queryStrings.push(
                `${sortRow.keyName}=${parseInt(value[listObjectKey])}`
              )
            })
            break
          case FieldDataType.DATE:
            if (value) {
              queryStrings.push(
                `${sortRow.keyName}=${value} 00:00:00&${sortRow.keyName}=${value} 23:59:59`
              )
            }
            break
          default:
            console.log(
              sortRow.dataType + ' : データタイプの指定が間違えています。'
            )
            break
        }
      })
      if (reslutsIsArray) {
        return queryStrings
      }
      // limit or offsetの値をセット
      for (let key in this.limitData) {
        queryStrings.push(`${key}=${this.limitData[key]}`)
      }
      var paramterStr = ''
      for (var i = 0; i < queryStrings.length; i++) {
        paramterStr += !i ? `?${queryStrings[i]}` : `&${queryStrings[i]}`
      }
      RouterUtils.updateQueryObjectToStorage(this.$route.name, paramterStr)
      return paramterStr
    },
    getGenCodeByName(value, isItemNo = null) {
      let result = ''
      if (!isItemNo || !Number.isInteger(value)) {
        return result
      }
      // get mstTables by isItemNo and has dataType = 2 from original tableLabels
      let mstTablesFilterd = this.tableLabels.filter(el => el.isItemNo === isItemNo && el.dataType === FieldDataType.LIST)
      if (mstTablesFilterd && mstTablesFilterd[0] && mstTablesFilterd[0].mstGenCode) {
        const originalMstGenCode = mstTablesFilterd[0].mstGenCode
        // get index item gen code exist code = value
        const indexOfItemGenCode = originalMstGenCode.findIndex(el => el.code === value)
        indexOfItemGenCode !== -1
          ? result = originalMstGenCode[indexOfItemGenCode].name // if exists, will get the name
          : result = value
      }
      return result
    },
    getBatchByDetails(batchObj) {
      return (batchObj.details && batchObj.details.length > 0) ? batchObj.details[0] : batchObj
    },
    hideDropdownCsv() {
      this.$refs.extOtherButtonDropdown.hideDropdown()
    },
    /**
     * Validate input value and return error if any.
     */
    onErrorText(msg) {
      if (msg === 'required') {
        FlashMessage.getInstance().showErrorMessage('列名が空です。列名を入力してください。')
      }
    },
    /**
     * Trigger when the user completes the name change
     */
    async onEditItemName(editedLabelName, batch) {
      const batchRequest = {batchNo: batch.batchNo, batchDetailNo: batch.batchDetailNo, memo: editedLabelName}
      try {
        await this.updateMemoRequest(batchRequest)
      } catch (error) {
        console.log(error)
      }
      await this.checkAndRefreshTableDataManually()
      this.handleDisplayEditIcon(batch.batchNo)
    },
    /**
     * When the user chooses to edit the name in the dialog filter
     */
    onEditLabel(batchNo) {
      this.$refs['externalEditableLabel' + batchNo][0].switchToEditMode()
      this.handleDisplayEditIcon(batchNo)
    },
    handleDisplayEditIcon(batchNo) {
      if (document.getElementById(`editIcon_${batchNo}`)) {
        this.editMode
          ? document.getElementById(`editIcon_${batchNo}`).style.display = 'none'
          : document.getElementById(`editIcon_${batchNo}`).style.display = 'block'
      }
    },
    async onDeleteEndedBatches() {
      const res = await this.taskValidateBeforeBackupToTaskHst()
      if (!res.data.result && res.data.checkingStep === 1) {
        this.displayModalFailedBackupToTaskHst('「締め」がありません', '締めているバッチが見つかりませんでした。')
        return
      }
      if (!res.data.result && res.data.checkingStep === 2) {
        this.displayModalFailedBackupToTaskHst('実行中のバッチがあります', '現在実行中のバッチを一時保留にするか、締めになるまでは履歴へ退避はできません。')
        return
      }
      this.isLoading = true
      await this.outputResultFile()
      await this.backupToHistory()
      await this.checkAndRefreshTableDataManually()
      FlashMessage.getInstance().showSuccessMessage('履歴退避完了。')
      this.isLoading = false
    },
    confirmDeleteBatchEnded() {
      const el = this.$createElement
      const contentBody = el('div', {
        domProps: {
          innerHTML: '<span>実績の出力と、以下の画面に表示されている締めバッチを削除し、タスク履歴へ記録します。<br/>削除したタスクを戻すことはできません。</span><br/><ul class="mb-0 list-unstyled"><li>・ダッシュボード</li><li>・作業管理のバッチ</li><li>・作業管理のタスク明細</li></ul><br/><p>処理する際は事前に他の担当者に周知し、全作業を停止してください。</p><p>処理はお時間に余裕を持って実行してください。</p>'
        }
      })
      this.$bvModal.msgBoxConfirm([contentBody], {
        title: '履歴へ退避',
        size: 'sm',
        okVariant: 'link text-dark text-decoration-none accept-button',
        cancelVariant: 'link text-dark text-decoration-none',
        okTitle: '処理開始',
        cancelTitle: 'キャンセル',
        id: 'modal_delete_batch_ended_confirm',
        footerClass: 'justify-content-around p-1',
        hideHeaderClose: true,
        centered: true
      })
        .then(async removeConfirm => {
          if (removeConfirm) {
            await this.onDeleteEndedBatches()
          }
        })
        .catch(() => {})
    },
    displayModalFailedBackupToTaskHst(title = '', content = '') {
      this.$bvModal.msgBoxOk(content, {
        title: title,
        size: 'sm',
        okVariant: 'link text-dark text-decoration-none',
        okTitle: '閉じる',
        id: 'modal_delete_batch_ended_confirm',
        footerClass: 'justify-content-around p-1',
        hideHeaderClose: true,
        centered: true
      })
        .then(removeConfirm => {
        })
        .catch(() => {})
    },
    /**
     * 指定したバッチ番号とバッチ詳細番号に基づいて、不足品リストを表示します。
     * @param {string} batchNo - 表示するバッチ番号
     * @param {string} batchDetailNo - 表示するバッチ詳細番号
     * @param {string} type - 表示タイプ、バッチ詳細番号が欠品モーダルに表示されます
     */
    async onShowMissList(batchNo, batchDetailNo, batchType) {
      const queryParam = { batchNo, batchDetailNo }
      this.isShowBatchDetailNo = batchType === BATCH_CHILDREN
      this.$refs['missing-items-modal'].showModal(queryParam)
    },
    /**
     * 新しい欠損データを取得する。
     */
    async fetchMissingData() {
      if (this.isShowMissingModal) {
        await this.$refs['missing-items-modal'].generateMissingItems()
      }
    },
    /**
     * 親バッチの高さを取得する。
     * @returns 身長
     */
    getHeightParentBatch() {
      const element = document.getElementsByClassName('parentBatch')[0]
      return element ? element.clientHeight + 'px' : 'auto'
    },
    /**
     * ウィンドウのサイズ変更。
     */
    onResize() {
      setTimeout(() => {
        this.heightOfChildBatch = this.getHeightParentBatch()
      }, 300)
    }
  }
}
</script>
<style lang="scss" scoped>
@mixin styleBlockBelowInfoParent() {
  flex-wrap: wrap;
  @media (max-width: 900px) {
    &__displayColumn {
      flex-direction: column;
    }
    &__displayRow {
      flex-direction: row;
    }
  }
}
.batch-name {
  margin-right: 1rem;
}
.batchList {
  /** Scroll bar */
  overflow-y: auto;
  /** Display & Box model */
  padding-right: 5px;
  height: 100% !important;
  &__emptyText {
    /** Display & Box model */
    width: 100%;
    margin-top: 20px;
    /** Text */
    text-align: center;
    color: $text_gray;
  }
  // display responsive parent batch
  .parentBatch {
    /** Display */
    display: flex;
    flex-direction: row;
    height: 100%;
    padding: 20px 0;
    &__batchStatus {
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      /** Text */
      font-weight: 400;
      /** Display & Box model */
      padding-right: 1rem;
      // 要素の幅が縮小しないようにする
      flex-shrink: 0;
      max-width: 220px;
      width: 6%;
      min-width: 6.25rem;
    }
    .blockAboveInfo {
      /** Display */
      display: flex;
      flex-direction: column;
      // 要素幅の縮小を受け入れる
      flex-shrink: 1;
      @media (max-width: 576px) {
        margin-right: 0px;
      }
      &__on {
        display: flex;
        justify-content: space-between;
        &__batchInfo {
          display: flex;
          align-items: center;
          .batch-info-ellipsis {
            @include textOverflowEllipsis(true);
            margin-right: 5px;
          }
          strong {
            font-weight: 700 !important;
          }
          margin: 0;
          margin-bottom: 6px;
        }
        &__action {
          display: flex;
          justify-content: flex-end;
          flex-shrink: 0;
          word-wrap: normal;
          .batch-action {
            display: flex;
            font-weight: 400;
            align-items: center;
            i {
              @include responsive-fs(16, true);
            }
            .icon-report {
              color: #B41B3E;
              display: flex;
              align-items: center;
              span {
                @include responsive-fs(16);
              }
            }
            .icon-list {
              display: flex;
              align-items: center;
            }
          }
        }
      }
      &__down {
        display: flex;
        align-items: center;
        @media (max-width: 900px) {
          flex-direction: column;
          align-items: flex-start;
        }
        &__batchNo {
          margin-right: 40px;
          small {
            @include responsive-fs(12, true);
          }
        }
        &__taskType {
          @include responsive-fs(12);
          margin-right: 40px;
          height: 100%;
          @include textOverflowEllipsis(true, 2);
          @media (max-width: 900px) {
            @include textOverflowEllipsis(true);
          }
        }
        &__memo {
          display: flex;
          align-items: center;
          .batch-memo {
            @include responsive-fs(14);
          }
          .edit_icon {
            color: #4E66A6;
            @include responsive-fs(18);
            &:hover {
              cursor: pointer;
            }
          }
          /deep/ .editableLabel-input {
            max-width: calc(100vw - 70vw) !important;
            width: calc(100vw - 70vw) !important;
            max-height: 21px !important;
            height: 21px !important;
          }
          /deep/ .editableLabel-label {
            @include textOverflowEllipsis(true, 2);
            @media (max-width: 900px) {
              @include textOverflowEllipsis(true);
            }
          }
        }
      }
    }
    .blockBelowInfo {
      /** Display */
      display: flex;
      /** Size */
      @include responsive-fs(12, true);
      @media (max-width: 900px) {
        margin-bottom: 8px;
      }
      &__serialId {
        width: auto;
        margin: 0;
        margin-right: 24px;
        display: flex;
        &__key, &__value {
          display: flex;
        }
        @include styleBlockBelowInfoParent();
      }
      &__insertTime {
        width: auto;
        margin: 0;
        margin-right: 24px;
        display: flex;
        &__key, &__value {
          display: flex;
        }
        @include styleBlockBelowInfoParent();
      }
      &__updateTime {
        width: auto;
        margin: 0;
        display: flex;
        &__key, &__value {
          display: flex;
        }
        @include styleBlockBelowInfoParent();
      }
    }
  }
  // display responsive children batch
  .childBatch {
    /** Display */
    display: flex;
    flex-direction: row;
    border-radius: 8px;
    padding: 20px 16px 20px 0;
    &__batchStatus {
      /** Display */
      display: flex;
      align-items: center;
      justify-content: center;
      /** Text */
      @include responsive-fs(16);
      font-weight: 400;
      width: 6%;
      min-width: 6.25rem;
    }
    .blockAboveInfo {
      /** Display */
      display: flex;
      align-items: center;
      @media (max-width: 450px) {
       margin: 32px 0;
      }
      &__batchNo {
        display: flex;
        align-items: center;
        small {
          font-weight: bold !important;
          @include responsive-fs(16, true);
          @include textOverflowEllipsis(true);
        }
      }
    }
    .btn-group {
      display: flex;
      align-items: center;
      justify-content: end;
      white-space: nowrap;
      .batch-action {
        margin-left: 8px;
        font-weight: 400;
        height: 21px;
        display: flex;
        align-items: center;
        i {
          @include responsive-fs(16);
        }
        .icon-report {
          color: #B41B3E;
          display: flex;
          align-items: center;
          span {
            @include responsive-fs(16);
          }
        }
        .icon-list {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
.custom-checkbox-label {
  @include responsive-fs(14);
}
.blockAction {
  display: flex;
  justify-content: space-between;
  &__left {
    display: flex;
    flex-direction: row;
  }
  &__right {
    padding-right: 6px;
    display: flex;
    flex-direction: row;
    .sortField {
      max-width: 500px;
      @include media-breakpoint-xx-large() {
        max-width: 320px;
      }
      width: 20vw;
      min-width: 240px;
    }
    .sortType {
      padding-left: 4px;
    }
  }
  &__totalRecords {
    margin-right: 16px;
    @include responsive-fs(12);
  }
  &__btnDeleteBatchEnd {
    @include responsive-fs(12);
    color: #252422;
    margin: 0 0 0 16px;
    .iconBtnDeleteBatchEnd {
      color: #4E66A6;
      @include responsive-fs(15);
    }
  }
  &__btnSearch {
    @include responsive-fs(12);
    .icon_search_btn {
      @include responsive-fs(14);
    }
    .handle_btn_search {
      color: #252422;
      padding: 4px 8px !important;
      background: rgba(78, 102, 166, 0.08) !important;
    }
  }
  &__blockTags {
    margin: 0 0 0 10px;
    .tag {
      background: rgba(78, 102, 166, 0.08);
      border-radius: 4px;
      color: #252422;
      display: flex;
      align-items: center;
      justify-content: center;
      @include responsive-fs(12, true);
      width: auto;
      height: 27px;
      margin-right: 10px;
      i {
        @include responsive-fs(16, true);
        padding: 8px 11px 8px 0;
        cursor: pointer;
      }
      .text {
        padding: 4px 7px 4px 8px;
      }
    }
  }
}
.btn-batch {
  min-width: 92px;
}
.b-dropdown >>> button {
  @include responsive-fs(11.2);
  color: #252422;
}
.card-batch {
  border-radius: 8px;
}
.card-batch-color {
  border: 1px solid rgba(78, 102, 166, 0.40);
}
.card-body {
  padding: 0 1rem !important;
  display: flex;
  flex-direction: row;
  @media (max-width: 1000px) {
    flex-direction: column;
  }
}
.child-batch-margin {
  margin: 0.2rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/mst-tables/BatchControl.vue